/*
 * User Reducer
 */
import {
  USER_CREATE,
  USER_CREATE_SUCCESS,
  USER_CREATE_ERROR,
  USER_MASS_CREATE,
  USER_MASS_CREATE_SUCCESS,
  USER_MASS_CREATE_ERROR,
  USER_EDIT,
  USER_EDIT_SUCCESS,
  USER_EDIT_ERROR,
  USER_DELETE,
  USER_DELETE_SUCCESS,
  USER_DELETE_ERROR,
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_ERROR,
} from './../actions/User';
import { CLEAR_ACTION_RESPONSE } from './../actions/Global';
import { Record, List, fromJS } from 'immutable';
import { convertAxiosSuccess, convertAxiosError } from './../utility/ConverterUtils';

/* The initial state of the App */
const UserStateRecord = Record({
  isLoading: false,
  actionResponse: null,
  users: List(),
  usersFailedOnMassCreate: List(),
});

const user = (state = new UserStateRecord({}), action) => {
  switch (action.type) {
    case GET_USERS:
      return userGetAll(state);
    case GET_USERS_SUCCESS:
      return userGetAllSuccess(state, action);
    case GET_USERS_ERROR:
      return userGetAllError(state, action);

    case USER_CREATE:
      return userCreate(state, action);
    case USER_CREATE_SUCCESS:
      return userCreateSuccess(state, action);
    case USER_CREATE_ERROR:
      return userCreateError(state, action);

    case USER_MASS_CREATE:
      return userMassCreate(state, action);
    case USER_MASS_CREATE_SUCCESS:
      return userMassCreateSuccess(state, action);
    case USER_MASS_CREATE_ERROR:
      return userMassCreateError(state, action);

    case USER_EDIT:
      return userEdit(state);
    case USER_EDIT_SUCCESS:
      return userEditSuccess(state, action);
    case USER_EDIT_ERROR:
      return userEditError(state, action);

    case USER_DELETE:
      return userDelete(state);
    case USER_DELETE_SUCCESS:
      return userDeleteSuccess(state, action);
    case USER_DELETE_ERROR:
      return userDeleteError(state, action);

    case CLEAR_ACTION_RESPONSE:
      return clearActionResponse(state);

    default:
      return state;
  }
};

const userGetAll = (state) => {
  return state.setIn(['isLoading'], true).setIn(['users'], state.users.clear());
};

const userGetAllSuccess = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['users'], fromJS(action.payload.result.users))
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const userGetAllError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

const userCreate = (state) => {
  return state.setIn(['isLoading'], true);
};

const userCreateSuccess = (state, action) => {
  const newList = state.users.push(fromJS(action.payload.result.user));
  return state
    .setIn(['isLoading'], false)
    .setIn(['users'], newList)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const userCreateError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

const userMassCreate = (state) => {
  return state
    .setIn(['isLoading'], true)
    .setIn(['usersFailedOnMassCreate'], state.usersFailedOnMassCreate.clear());
};

const userMassCreateSuccess = (state, action) => {
  let failedList = state.usersFailedOnMassCreate;
  let newList = state.users;
  action.payload.result.users.forEach((value) => {
    if (!value.id) {
      failedList = failedList.push(fromJS(value));
    } else {
      newList = newList.push(fromJS(value));
    }
  });

  return state
    .setIn(['isLoading'], false)
    .setIn(['users'], newList)
    .setIn(['usersFailedOnMassCreate'], failedList)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const userMassCreateError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

const userEdit = (state) => {
  return state.setIn(['isLoading'], true);
};

const userEditSuccess = (state, action) => {
  const newList = state.users.update(
    state.users.findIndex((item) => item.get('id') === action.payload.result.user.id),
    (oldItem) => fromJS(action.payload.result.user)
  );
  return state
    .setIn(['isLoading'], false)
    .setIn(['users'], newList)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const userEditError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

const userDelete = (state) => {
  return state.setIn(['isLoading'], true);
};

const userDeleteSuccess = (state, action) => {
  const newList = state.users.filter((item) => item.get('id') !== action.payload.result.user.id);
  return state
    .setIn(['isLoading'], false)
    .setIn(['users'], newList)
    .setIn(['actionResponse'], fromJS(convertAxiosSuccess(action)));
};

const userDeleteError = (state, action) => {
  return state
    .setIn(['isLoading'], false)
    .setIn(['actionResponse'], fromJS(convertAxiosError(action)));
};

/** Clears the reducer errors */
const clearActionResponse = (state) => {
  return state.setIn(['actionResponse'], null);
};

export default user;
